import * as React from 'react';

export type PopoverMenuContextValue = {
  closeMenu: () => void;
};

export const PopoverMenuContext =
  React.createContext<PopoverMenuContextValue | null>(null);

export const usePopoverMenuContext = () => {
  const context = React.useContext(PopoverMenuContext);
  if (!context) {
    throw new Error('PopoverMenu components must be used within PopoverMenu.');
  }
  return context;
};
